<div style="display:none">{{changeDetect|async}}</div>
<form [formGroup]="formlyForm" class="control-attributes active-control">
  <formly-form style="width: 100%;" [model]="model" [fields]="fields" [options]="options" [form]="formlyForm"></formly-form>
</form>
